import { connect } from 'react-redux';

import { RootReducerStateT } from 'app/reducers/rootReducer';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { actions as personalActions } from '../../settings/actions/personal';
import ConversationSidebar from '../components/sidebar/conversationSidebar';

const mapStateToProps = (state: RootReducerStateT) => {
  return {
    metaConversation: state.conversation.metaConversation,
    conversationCardsSettings: state.settings.personal.conversationCards,
    isMenuOpen: state.settings.personal.isCustomCardMenuOpen,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateConversationCards: bindActionToPromise(
      dispatch,
      personalActions.personalConversationCards,
    ),
    toggleCustomCardMenu: bindActionToPromise(
      dispatch,
      personalActions.personalCustomCardMenu,
    ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConversationSidebar);
